module.exports = __webpack_public_path__ + "media/images/play-log-b7087272582bd8498349ff72ebe86b7e.svg";